import React from 'react';

export default class Message extends React.Component {

    constructor() {
        super();
    }

    render() {
        const { text } = this.props;
        return (
            <>
                <p className='message' dangerouslySetInnerHTML={{ __html: text }}></p>
            </>
        )
    }
}
